import { css } from 'linaria';
import { usePopover, popoverBase } from 'components/popover/popover';
import { LOGIN_URL, SIGNUP_URL } from 'common/constants';
import classNames from 'classnames';
import { buttonReset } from 'components/buttons/button-reset';
import Link from 'next/link';
import { useTranslation, Trans } from 'next-i18next';
import { SaveIcon } from '@pocket/web-ui';
import { SaveFilledIcon } from '@pocket/web-ui';
import { ReadingIcon } from '@pocket/web-ui';
const saveContainer = "sb4ns5w";
const popoverContainer = "pbl8oim";
export const SavePopover = function ({
  popoverRef,
  id
}) {
  const loginUrl = `${LOGIN_URL}?route=${global.location.href}`;
  const signupUrl = `${SIGNUP_URL}?route=${global.location.href}`;
  return (//prettier-ignore
    <div className={popoverContainer} ref={popoverRef} data-cy={`article-save-login-popup-${id}`}>
      <Trans i18nKey="item-action:no-auth-save">
        <a className="popoverLink" href={loginUrl} data-cy="save-login">Log in</a> or{' '}
        <a className="popoverLink" href={signupUrl} data-cy="save-signup">Sign up</a> to save this article.
      </Trans>
    </div>
  );
};
/**
 * Pocket logomark with click interaction to save a story to Pocket.
 */

export const SaveToPocket = function ({
  url,
  onOpen,
  openExternal,
  saveAction,
  isAuthenticated,
  saveStatus = 'unsaved',
  allowRead = false,
  hideCopy = false,
  className,
  id
}) {
  const {
    t
  } = useTranslation();
  const saveCopy = {
    unsaved: t('item-action:save-unsaved', 'Save'),
    saving: t('item-action:save-saving', 'Save'),
    saved: t('item-action:save-saved', 'Saved')
  };

  const handleClick = event => {
    event.preventDefault();
    event.stopPropagation();
    saveAction(isAuthenticated);
  }; // Popover Effect


  const {
    popTrigger,
    popBody,
    shown
  } = usePopover({
    placement: 'top-start',
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 0]
      }
    }]
  });
  const saveClasses = classNames(buttonReset, saveContainer, saveStatus, 'card-actions', allowRead && 'read-now', className);
  return saveStatus === 'saved' && allowRead ? <Link href={url}>
      <a data-cy={`article-read-now-${id}`} onClick={onOpen} className={saveClasses} target={openExternal ? '_blank' : undefined}>
        <ReadingIcon />
        {hideCopy ? null : <span className="actionCopy">{t('item-action:read-now', 'Read Now')}</span>}
      </a>
    </Link> : <>
      <button className={saveClasses} onClick={handleClick} ref={popTrigger} data-cy={`article-save-btn-${id}`}>
        {saveStatus === 'saved' ? <SaveFilledIcon /> : <SaveIcon />}
        {hideCopy ? null : <div className="actionCopy">{saveCopy[saveStatus]}</div>}
      </button>
      {!isAuthenticated && shown ? <SavePopover popoverRef={popBody} id={id} /> : null}
    </>;
};

require("./save-to-pocket.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./save-to-pocket.js");